<template>
    <div class="LocationList" style="display:flex;flex-direction:column; max-height:85vh;">
        <h2>Location List <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh client-list" /></h2>
        <div class="table-filters client-list">
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Program:</label>
                        <select class="form-control" v-model="Filters.SubProgramID" @change="RefreshDataTable">
                            <option v-for="option in SubProgramOptions" v-bind:value="option.value">{{ option.text }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Active:</label>
                        <select class="form-control" v-model="Filters.IsActive" @change="RefreshDataTable">
                            <option value="All">All</option>
                            <option value="True">Active</option>
                            <option value="False">Inactive</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    Displaying {{NumberOfLocations}} Records
                </div>
                <div class="col-sm-4"></div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Search Locations:</label>
                        <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                    </div>
                </div>
            </div>
        </div>
        <div style="overflow:auto;">
            <vuetable :fields="LocationsTableOptions.Fields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :data-manager="DataManager"
                      ref="datatable"
                      id="locationslistdatatableid">

                <template slot="LocationRecordName" scope="props">
                    <div class="LocationRecordName">
                        <span class="underline pointer" @click="OpenLocationRecord(props.rowData.Id, props.rowData)" v-html="props.rowData.Name"></span>
                    </div>
                </template>
            </vuetable>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '../../../services/event-bus.js';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);

    export default {
        name: "LocationList",
        props: [],
        data: function () {
            return {
                search: "",
                NumberOfLocations: '',
                Filters: {
                    SubProgramID: "",
                    IsActive: 'True'
                },

                LocationsTableOptions: {
                    Fields: [
                        {
                            name: '__slot:LocationRecordName',
                            title: 'Name',
                            sortField: 'Name',
                        },
                        {
                            name: 'CurrentOccupancy',
                            title: 'Clients',
                            callback: (value) => (value === -1) ? 0 : value,
                            sortField: 'CurrentOccupancy',
                        },
                        {
                            name: 'AddressLine1',
                            title: 'Address',
                            sortField: 'AddressLine1',
                        },
                        {
                            name: 'AddressLine2',
                            title: 'Unit',
                            sortField: 'AddressLine2',
                        },
                        {
                            name: 'City',
                            title: 'City',
                            sortField: 'City',
                        },
                        {
                            name: 'ZipCode',
                            title: 'ZipCode',
                            sortField: 'ZipCode',
                        },
                    ]
                }
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetLocations();
            },

            //// Returns the name of the worker that has role TeamMemberRole
            //CurrentRole(CurrentTeamMembers, TeamMemberRole) {
            //    let filteredList = CurrentTeamMembers.filter(r => r.EndDate == null && r.EmployeeRole == TeamMemberRole);
            //    if (filteredList.length > 0) {
            //        return filteredList.map(e => e.Employee.Person.FullName).join(', ');
            //    } else {
            //        return "UNASSIGNED"
            //    }
            //},
            //ClientCount(currentClients) {
            //    return currentClients.length;
            //},

            // TO DO: Get supervisors

            GetLocations() {
                // Use Master API to call GetResidencesForSubProgram endpoint
                this.$MasterAPI.ExecuteRequest("GET", 'TAY/Location/GetResidencesForSubProgram',
                    {
                        Id: this.Filters.SubProgramID,
                        IsActive: this.Filters.IsActive
                        //SubprogramID: this.Filters.SubprogramID,
                        //SupervisorID: this.Filters.SupervisorID
                    }, this.GetLocationsSuccess, this.GetLocationsError, true
                )
            },
            GetLocationsSuccess(response) {
                this.$store.commit("Residences.ResidenceList.Replace", response.data.data);
                this.$refs.datatable.refresh();
            },
            GetLocationsError(response) {
                console.log("Some error occurred");
            },
            // Adds the location record in the LocationPane component
            OpenLocationRecord(LocationID, LocationRecordData) {
                // Append team data to team profiles
                this.$store.commit("Residences.ResidenceProfiles.Append", LocationRecordData);
                // Change pane
                this.$parent.ChangePaneShown(LocationID);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.LoadedLocations);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                        
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfLocations = visibleData.length;
                return visibleData;                  
            },
        },

        components: {
            Vuetable,
            EventBus
        },

        computed: {
            LoadedLocations: function () {
                // gets the Client Enrollment List from the store
                return this.$store.state.Residences.ResidenceList;
            },
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            }
        },

        mounted() {
            var vm = this;
            //Get Location Records*/
            this.Filters.SubProgramID = this.SubProgramOptions[0].value;
            this.GetLocations();
            
            let getLocationsFunc = function () {
                vm.GetLocations();
            };
            this.$GlobalUpdate.AddGlobalUpdateFunction(getLocationsFunc);
        }
    }
</script>

<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>